/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable import/first */
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@material-ui/styles';
import { MuiThemeProvider as MuiThemeProviderV0 } from 'material-ui';
import { communityThemeV0, communityTheme } from '../theme/CommunityTheme';
import Header from '../containers/PageStructure/Header/HeaderContainer';
import ErrorHandlerContainer from '../containers/PageStructure/ErrorHandler/ErrorHandlerContainer';
import HeaderNew from '../containers/PageStructure/Header/HeaderContainerNew';
import CommunityTabs from '../components/common/Tabs/Tabs';
import CommunityAppBar from '../components/common/AppBar/AppBar';

const CommunityLayoutV0 = ({ children }) => (
  <MuiThemeProviderV0 muiTheme={communityThemeV0}>
    <section className="page">
      <Header />
      {children}
      <ErrorHandlerContainer />
    </section>
  </MuiThemeProviderV0>
);

CommunityLayoutV0.propTypes = {
  children: PropTypes.node.isRequired,
};

const CommunityLayout = ({ children }) => (
  <ThemeProvider theme={communityTheme}>
    <section className="page-wrapper">
      <CommunityAppBar />
      <CommunityTabs />
      {children}
    </section>
  </ThemeProvider>
);

CommunityLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

const CommunityLayoutCombined = ({ children }) => (
  <ThemeProvider theme={communityTheme}>
    <section className="page">
      <HeaderNew />
      <MuiThemeProviderV0 muiTheme={communityThemeV0}>
        <React.Fragment>
          {children}
          <ErrorHandlerContainer />
        </React.Fragment>
      </MuiThemeProviderV0>
    </section>
  </ThemeProvider>
);

CommunityLayoutCombined.propTypes = {
  children: PropTypes.node.isRequired,
};

export { CommunityLayout, CommunityLayoutV0, CommunityLayoutCombined };
